module Meevo.Components.Controls {
    "use strict";

    //import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    //import SecurityParts = Meevo.Components.Common.SecurityParts;

    export class MeevoList {

        restrict = 'E';
        require = '^form'; // require own directive controller for controller function


        link = ($scope: any, element: any, attributes: any, formCtrl: any) => {

            /**
             * to use, attach "collection" as an attribute on the meevo-list and
             * pass in the collection name from selectedSection.model['COLLECTION_NAME']
             */
            //get current collection name
            var list = attributes.collection;
            // expose local scope function to meevo-list child scope for crud

            $scope.addItem = function () {
                // push empty object to collection to add new repeat item
                var emptyItem = {};
                var parentModel = $scope.$parent.$parent.context.selectedSection.model;
                if (parentModel[list] == null)
                    parentModel[list] = [];

                var parentList = parentModel[list];

                parentList.unshift(emptyItem);
            };
            // expose local scope function to meevo-list child scope for crud
            $scope.removeItem = (item) => {
              // objectState = 2028   == deleted
                // gets the collection attribute and goes up parent scope to get current list from the context
                var result = $scope.$parent.$parent.context.modalService.confirm("Do you want to delete this?", 0).then((data) => {
                    var parentList = $scope.$parent.$parent.context.selectedSection.model[list];
                    var index = parentList.indexOf(item);

                    parentList.splice(index, 1);
                });

                
            };



        };

        constructor() {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoList();
            }

           // directive.$inject = ["meevo.components.common.DataService", "meevo.components.modal.ModalService", "meevo.components.logging.LoggingService", "$mdDialog", "meevo.components.common.SecurityService", "meevo.components.busy.BusyService"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoList", MeevoList.factory());
}
